import angular from 'angular';
import _ from 'lodash';

// import DiscardedIdentifier from '../data/seller/discarded-identifier.data';
// import SubEntity from '../data/seller/sub-entity.data';
// import BillingWarrant from '../data/seller/billing-warrant.data';

(function () {
    'use strict';
    angular.module('app.core').factory('invitedEntityDA', invitedEntityDA);

    invitedEntityDA.$inject = ['Restangular', 'CONF', 'InvitedEntity', 'InvitedEntityBo', 'InvBuyerRelation', '$http'];

    /**
     * Accès à l'API concernant les fournisseurs (sellers)
     */

    /* @ngInject */
    function invitedEntityDA(Restangular, CONF, InvitedEntity, InvitedEntityBo, InvBuyerRelation, $http) {
        var version = 'v1';
        var baseUrl = 'invitedEntity';
        var baseUrlSubEntities = 'legal-entity/sub-entities/re-invite'

        var exports = {
            searchFiltredInvitedEntity: searchFiltredInvitedEntity,
            searchInvitedEntitys: searchInvitedEntitys,
            getInvitedEntitySeller: getInvitedEntitySeller,
            getInvitedEntityBuyer: getInvitedEntityBuyer,
            searchInvBuyerRelations: searchInvBuyerRelations,
            canActivateInvitedEntity: canActivateInvitedEntity,
            activateInvitedEntity: activateInvitedEntity,
            deleteInvitedEntity: deleteInvitedEntity,
            resendInvitation: resendInvitation,
            reInviteRejectedSubEntities: reInviteRejectedSubEntities,
            updateSellerRobotKey: updateSellerRobotKey,
        };

        return exports;

        // ////////////////

        function searchInvitedEntitys(searchValue) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .all(baseUrl)
                .post({value: searchValue})
                .then(function (pageInvitedEntitys) {
                    return _.map(pageInvitedEntitys.content, function (s) {
                        return new InvitedEntity(s);
                    });
                });
        }

        function searchFiltredInvitedEntity(InvitedEntityFilter) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .oneUrl(baseUrl)
                .all('search')
                .post(InvitedEntityFilter)
                .then(function (pageInvitedEntity) {
                    return {
                        totalItems: pageInvitedEntity.totalElements,
                        invitedEntities: _.map(pageInvitedEntity.content, function (u) {
                            return new InvitedEntity(u);
                        }),
                    };
                });
        }

        /**
         * Recupere un compte invité de type Seller
         *
         * @param {string} sellerId - Identifiant du fournisseur.
         */
        function getInvitedEntitySeller(sellerId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .oneUrl(baseUrl)
                .one(sellerId)
                .one('seller')
                .get()
                .then(function (invitedEntityBo) {
                    return new InvitedEntityBo(invitedEntityBo);
                });
        }

        /**
         * Recupere un compte invité de type Seller
         *
         * @param {string} buyerId - Identifiant du client.
         */
        function getInvitedEntityBuyer(buyerId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .oneUrl(baseUrl)
                .one(buyerId)
                .one('buyer')
                .get()
                .then(function (invitedEntityBo) {
                    return new InvitedEntityBo(invitedEntityBo);
                });
        }

        /**
         * Récupère toutes les relations pour un client invité.
         */
        function searchInvBuyerRelations(invBuyerId, invBuyerRelationFilter) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, invBuyerId)
                .all('search-buyer-relations')
                .post(invBuyerRelationFilter)
                .then(function (relations) {
                    return _.map(relations, function (r) {
                        return new InvBuyerRelation(r);
                    });
                });
        }

        /**
         * Vérification de la possibilité d'activation d'une entité invitée ayant signalé une erreur lors de la validation de son inscription.
         * @param {number} invitedEntityId - identifiant de l'entité invitée.
         */
        function canActivateInvitedEntity(invitedEntityId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, invitedEntityId)
                .one('can-activate')
                .get();
        }

        /**
         * Activation d'une entité invitée ayant signalé une erreur lors de la validation de son inscription.
         * @param {number} invitedEntityId - identifiant de l'entité invitée.
         */
        function activateInvitedEntity(invitedEntityId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, invitedEntityId)
                .one('activate')
                .get();
        }

        /**
         * Supprime un compte invité.
         * @param invitedentityId Identifiant du compte invité
         */
        function deleteInvitedEntity(invitedentityId) {
            return Restangular.oneUrl(CONF.apiBaseUrl).oneUrl(version).one(baseUrl, invitedentityId).remove();
        }

        /**
         * Réémettre une invitation d'un DO
         */
        function resendInvitation(invitationId, invitationEmail) {
            var url =
                CONF.apiContext +
                CONF.apiBaseUrl +
                '/' +
                version +
                '/' +
                baseUrl +
                '/resendInvitation?invitationId=' +
                invitationId +
                '&invitationEmail=' +
                invitationEmail;
            return $http.post(url);
        }

        /**
         * Réinviter des établissements rejetés
         */
        function reInviteRejectedSubEntities(subEntitiesCodes, invitedEntityId) {
            var url = CONF.apiContext + CONF.apiBaseUrl + '/' + version + '/' + baseUrlSubEntities + '?rejectedCodes=' +
                subEntitiesCodes + '&invitedEntityId=' + invitedEntityId;
            return $http.post(url);
        }

        /**
         * Permet de modifier le code émetteur du fournisseur invité
         */
        function updateSellerRobotKey(invitedEntityId, sellerRobotKey) {
            let url = CONF.apiContext +
                CONF.apiBaseUrl +
                '/' +
                version +
                '/' +
                baseUrl +
                '/' +
                invitedEntityId +
                '/update-robot-key/' +
                sellerRobotKey;
            return $http.post(url);
        }
    }
})();
